module.exports = __webpack_public_path__ + "static/media/savings.6dbd53f8.png";